// import React, { useState, useEffect } from "react";
// import SelectAddressModal from "../../components/UserSideComponents/Order/SelectAddressModal";
// import CheckoutSkeleton from "../../components/UserSideComponents/Order/CheckOutSkeleton";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// import { handleRazorpayPayment } from "../../utils/razorpay";
// import { useCart } from "../../utils/CartContext";
// import { useCurrency } from "../../context/CurrencyContext";
// import { formatingPrice } from "../../utils/formatingPrice";
// import { useTranslation } from "react-i18next";

// const Checkout = () => {
//   const { currency, convertPrice } = useCurrency();
//   const { t, i18n } = useTranslation();
//   const currentLanguage = i18n.language || "en";

//   const [formData, setFormData] = useState({
//     paymentMethod: "cash",
//   });
//   const navigate = useNavigate();
//   const { fetchCartCount } = useCart();
//   const [cartData, setCartData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedAddressId, setSelectedAddressId] = useState(null);
//   const [isPlacingOrder, setIsPlacingOrder] = useState(false);
//   const [productData, setProductData] = useState(null);
//   const [isBuyNow, setIsBuyNow] = useState(false);

//   // Helper function to get localized text
//   const getLocalizedText = (item, field) => {
//     if (!item || !item[field]) return "";
    
//     // If value is a string (backward compatibility)
//     if (typeof item[field] === 'string') {
//       return item[field];
//     }
    
//     // If value is an object with language keys
//     if (typeof item[field] === 'object') {
//       return item[field][currentLanguage] || 
//              item[field].en || 
//              item[field].hi || 
//              item[field].es || 
//              item[field].zh || 
//              "";
//     }
    
//     return "";
//   };

//   const getUserData = () => {
//     const userData = localStorage.getItem("pm-user-data");
//     return userData ? JSON.parse(userData) : null;
//   };

//   useEffect(() => {
//     const buyNowProduct = localStorage.getItem("buy-now-product");
//     if (buyNowProduct) {
//       setProductData(JSON.parse(buyNowProduct));
//       setIsBuyNow(true);
//       setLoading(false);
//     } else {
//       fetchUserCart();
//     }
//   }, []);

//   const fetchUserCart = async () => {
//     try {
//       const userData = getUserData();
//       if (!userData || !userData._id) {
//         throw new Error(t("checkout.user_not_found") || "User not found. Please login first.");
//       }

//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/cart/get-users-cart/${userData._id}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(t("checkout.cart_fetch_failed") || "Failed to fetch cart data");
//       }

//       const data = await response.json();
//       setCartData(data);
//       setLoading(false);
//     } catch (err) {
//       setError(err.message);
//       setLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleAddressSelect = (addressId) => {
//     setSelectedAddressId(addressId);
//   };

//   const clearUserCart = async (userId) => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/cart/clear-cart?userId=${userId}`,
//         {
//           method: "DELETE",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(t("checkout.clear_cart_failed") || "Failed to clear cart");
//       }

//       const result = await response.json();
//       console.log("Cart cleared successfully:", result);
//       return result;
//     } catch (error) {
//       console.error("Error clearing cart:", error);
//       throw error;
//     }
//   };

//   const placeOrder = async () => {
//     try {
//       setIsPlacingOrder(true);
//       const userData = getUserData();

//       if (!userData || !userData._id) {
//         throw new Error(t("checkout.user_not_found") || "User not found. Please login first.");
//       }

//       if (!selectedAddressId) {
//         throw new Error(t("checkout.select_address") || "Please select a shipping address.");
//       }

//       let orderData;

//       if (isBuyNow) {
//         // Handle Buy Now order
//         if (!productData) {
//           throw new Error(t("checkout.no_product_data") || "No product data found.");
//         }

//         orderData = {
//           userId: userData._id,
//           products: [
//             {
//               product: productData.product._id,
//               quantity: productData.quantity,
//             },
//           ],
//           shippingAddress: selectedAddressId,
//           paymentMethod: formData.paymentMethod,
//         };
//       } else {
//         // Handle regular cart order
//         if (!cartData || !cartData.items || cartData.items.length === 0) {
//           throw new Error(t("checkout.cart_empty") || "Your cart is empty.");
//         }

//         const products = cartData.items.map((item) => ({
//           product: item.product._id,
//           quantity: item.quantity,
//         }));

//         orderData = {
//           userId: userData._id,
//           products: products,
//           shippingAddress: selectedAddressId,
//           paymentMethod: formData.paymentMethod,
//         };
//       }

//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/orders/place-order`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(orderData),
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || t("checkout.order_failed") || "Failed to place order");
//       }

//       const result = await response.json();
//       console.log("Order placed successfully:", result);

//       // Clear buy-now-product from localStorage if it exists
//       if (isBuyNow) {
//         localStorage.removeItem("buy-now-product");

//         // Update cart count in navbar
//         fetchCartCount();
//       } else {
//         try {
//           await clearUserCart(userData._id);
//           setCartData({ items: [] });

//           // Update cart count in navbar
//           fetchCartCount();
//         } catch (cartError) {
//           console.error(
//             "Failed to clear cart after order placement:",
//             cartError
//           );
//         }
//       }

//       Swal.fire({
//         title: t("checkout.order_success_title") || "Order placed successfully!",
//         text: isBuyNow
//           ? t("checkout.buy_now_success") || "Your product has been ordered."
//           : t("checkout.cart_order_success") || "Your order has been placed and cart cleared.",
//         icon: "success",
//         confirmButtonText: t("checkout.ok") || "OK",
//         draggable: true,
//       }).then((result) => {
//         if (result.isConfirmed) {
//           navigate("/user-orders");
//         }
//       });
//     } catch (err) {
//       console.error("Error placing order:", err);
//       Swal.fire({
//         title: t("checkout.error") || "Error!",
//         text: `${t("checkout.order_error_prefix") || "Error placing order:"} ${err.message}`,
//         icon: "error",
//         draggable: true,
//       });
//     } finally {
//       setIsPlacingOrder(false);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const userData = getUserData();
//     const totalAmount = isBuyNow ? calculateBuyNowTotal() : calculateTotal();

//     if (formData.paymentMethod === "cash") {
//       placeOrder(); // COD
//     } else {
//       handleRazorpayPayment({
//         amount: totalAmount,
//         user: userData,
//         onSuccess: () => placeOrder(), // place order AFTER payment success
//         onFail: () => Swal.fire(
//           t("checkout.error") || "Error", 
//           t("checkout.payment_failed") || "Payment failed", 
//           "error"
//         ),
//       });
//     }
//   };

//   // Calculate functions for Buy Now product
//   const calculateBuyNowSubtotal = () => {
//     if (!productData) return 0;
//     return productData.product.price * productData.quantity;
//   };

//   const calculateBuyNowShipping = () => {
//     if (!productData) return 0;
//     const shippingCharge = productData.product.shippingCharge || 0;
//     return shippingCharge * productData.quantity;
//   };

//   const calculateBuyNowGST = () => {
//     if (!productData) return 0;
//     const gstPercentage = productData.product.gstPercentage || 0;
//     return (
//       (productData.product.price * productData.quantity * gstPercentage) / 100
//     );
//   };

//   const calculateBuyNowExtraTax = () => {
//     if (!productData) return 0;
//     const extraTaxPercentage = productData.product.extraTaxPercentage || 0;
//     return (
//       (productData.product.price * productData.quantity * extraTaxPercentage) /
//       100
//     );
//   };

//   const calculateBuyNowTotal = () => {
//     const subtotal = calculateBuyNowSubtotal();
//     const shipping = calculateBuyNowShipping();
//     const gst = calculateBuyNowGST();
//     const extraTax = calculateBuyNowExtraTax();
//     return subtotal + shipping + gst + extraTax;
//   };

//   // Calculate functions for Cart products
//   const calculateSubtotal = () => {
//     if (!cartData || !cartData.items) return 0;
//     return cartData.items.reduce((total, item) => {
//       return total + item.product.price * item.quantity;
//     }, 0);
//   };

//   const calculateShipping = () => {
//     if (!cartData || !cartData.items) return 0;
//     return cartData.items.reduce((total, item) => {
//       const shippingCharge = item.product.shippingCharge || 0;
//       return total + shippingCharge * item.quantity;
//     }, 0);
//   };

//   const calculateGST = () => {
//     if (!cartData || !cartData.items) return 0;
//     return cartData.items.reduce((total, item) => {
//       const gstPercentage = item.product.gstPercentage || 0;
//       return total + (item.product.price * item.quantity * gstPercentage) / 100;
//     }, 0);
//   };

//   const calculateExtraTax = () => {
//     if (!cartData || !cartData.items) return 0;
//     return cartData.items.reduce((total, item) => {
//       const extraTaxPercentage = item.product.extraTaxPercentage || 0;
//       return (
//         total + (item.product.price * item.quantity * extraTaxPercentage) / 100
//       );
//     }, 0);
//   };

//   const calculateTotal = () => {
//     const subtotal = calculateSubtotal();
//     const shipping = calculateShipping();
//     const gst = calculateGST();
//     const extraTax = calculateExtraTax();
//     return subtotal + shipping + gst + extraTax;
//   };

//   const isOrderValid = () => {
//     if (isBuyNow) {
//       return productData && selectedAddressId && !isPlacingOrder;
//     } else {
//       return (
//         cartData &&
//         cartData.items &&
//         cartData.items.length > 0 &&
//         selectedAddressId &&
//         !isPlacingOrder
//       );
//     }
//   };

//   if (loading) {
//     return (
//       <div>
//         <CheckoutSkeleton />
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen bg-[#FBFBFB] flex items-center justify-center">
//         <div className="text-center">
//           <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
//             {t("checkout.error") || "Error"}: {error}
//           </div>
//           <button
//             onClick={isBuyNow ? () => navigate("/") : fetchUserCart}
//             className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded"
//           >
//             {isBuyNow 
//               ? t("checkout.go_home") || "Go to Home" 
//               : t("checkout.retry") || "Retry"}
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="py-10 bg-[#FBFBFB]">
//       <div className="mx-auto px-4 md:px-10">
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//           <div className="lg:col-span-2">
//             <SelectAddressModal onAddressSelect={handleAddressSelect} />
//           </div>

//           <div className="lg:col-span-1">
//             <div className="bg-white rounded-lg shadow-sm p-6 sticky top-6">
//               <h2 className="text-xl font-semibold font-philosopher mb-6">
//                 {t("checkout.order_summary") || "Order Summary"}
//               </h2>

//               <div className="space-y-4 mb-6">
//                 {isBuyNow ? (
//                   productData ? (
//                     <div className="flex items-center space-x-3">
//                       <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden">
//                         <img
//                           className="h-full w-full object-cover"
//                           src={productData.product.images?.[0] || "https://via.placeholder.com/100x100?text=Product"}
//                           alt={getLocalizedText(productData.product, "name") || t("checkout.untitled_product") || "Untitled Product"}
//                           onError={(e) => {
//                             e.target.src = "https://via.placeholder.com/100x100?text=Product";
//                           }}
//                         />
//                       </div>
//                       <div className="flex-1">
//                         <h4 className="font-medium text-sm">
//                           {getLocalizedText(productData.product, "name") || t("checkout.untitled_product") || "Untitled Product"}
//                         </h4>
//                         <p className="text-sm text-gray-500">
//                           x{productData.quantity}
//                         </p>
//                         <p className="text-xs text-gray-400">
//                           {getLocalizedText(productData.product, "measurement") || ""}
//                         </p>
//                       </div>
//                       <span className="font-semibold">
//                         {formatingPrice(
//                           convertPrice(productData.product.price * productData.quantity),
//                           currency
//                         )}
//                       </span>
//                     </div>
//                   ) : (
//                     <div className="text-center py-8 text-gray-500">
//                       {t("checkout.no_product") || "No product found"}
//                     </div>
//                   )
//                 ) : cartData && cartData.items && cartData.items.length > 0 ? (
//                   cartData.items.map((item) => {
//                     const productName = getLocalizedText(item.product, "name") || t("checkout.untitled_product") || "Untitled Product";
//                     const measurement = getLocalizedText(item.product, "measurement") || "";
                    
//                     return (
//                       <div key={item._id} className="flex items-center space-x-3">
//                         <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden">
//                           <img
//                             className="h-full w-full object-cover"
//                             src={item.product.images?.[0] || "https://via.placeholder.com/100x100?text=Product"}
//                             alt={productName}
//                             onError={(e) => {
//                               e.target.src = "https://via.placeholder.com/100x100?text=Product";
//                             }}
//                           />
//                         </div>
//                         <div className="flex-1">
//                           <h4 className="font-medium text-sm line-clamp-2">
//                             {productName}
//                           </h4>
//                           <p className="text-sm text-gray-500">
//                             x{item.quantity}
//                           </p>
//                           {measurement && (
//                             <p className="text-xs text-gray-400">
//                               {measurement}
//                             </p>
//                           )}
//                         </div>
//                         <span className="font-semibold whitespace-nowrap">
//                           {formatingPrice(
//                             convertPrice(item.product.price * item.quantity),
//                             currency
//                           )}
//                         </span>
//                       </div>
//                     );
//                   })
//                 ) : (
//                   <div className="text-center py-8 text-gray-500">
//                     {t("checkout.cart_empty_display") || "Your cart is empty"}
//                   </div>
//                 )}
//               </div>

//               {(isBuyNow && productData) ||
//               (cartData && cartData.items && cartData.items.length > 0) ? (
//                 <div className="border-t pt-4 space-y-2">
//                   <div className="flex justify-between text-sm">
//                     <span>{t("checkout.subtotal") || "Subtotal"}:</span>
//                     <span>
//                       {formatingPrice(
//                         convertPrice(
//                           isBuyNow
//                             ? calculateBuyNowSubtotal()
//                             : calculateSubtotal()
//                         ),
//                         currency
//                       )}
//                     </span>
//                   </div>
//                   <div className="flex justify-between text-sm">
//                     <span>{t("checkout.shipping") || "Shipping"}:</span>
//                     <span>
//                       {formatingPrice(
//                         convertPrice(
//                           isBuyNow
//                             ? calculateBuyNowShipping()
//                             : calculateShipping()
//                         ),
//                         currency
//                       )}
//                     </span>
//                   </div>
//                   <div className="flex justify-between text-sm">
//                     <span>{t("checkout.gst") || "GST"}:</span>
//                     <span>
//                       {formatingPrice(
//                         convertPrice(
//                           isBuyNow ? calculateBuyNowGST() : calculateGST()
//                         ),
//                         currency
//                       )}
//                     </span>
//                   </div>
//                   <div className="flex justify-between text-sm">
//                     <span>{t("checkout.extra_tax") || "Extra Tax"}:</span>
//                     <span>
//                       {formatingPrice(
//                         convertPrice(
//                           isBuyNow
//                             ? calculateBuyNowExtraTax()
//                             : calculateExtraTax()
//                         ),
//                         currency
//                       )}
//                     </span>
//                   </div>
//                   <div className="flex justify-between font-semibold font-philosopher text-lg pt-2 border-t">
//                     <span>{t("checkout.total") || "Total"}:</span>
//                     <span>
//                       {formatingPrice(
//                         convertPrice(
//                           isBuyNow ? calculateBuyNowTotal() : calculateTotal()
//                         ),
//                         currency
//                       )}
//                     </span>
//                   </div>
//                 </div>
//               ) : null}

//               <div className="mt-6">
//                 <h3 className="font-semibold text-xl font-philosopher mb-4">
//                   {t("checkout.payment_method") || "Payment Method"}
//                 </h3>
//                 <div className="space-y-3">
//                   <label className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors">
//                     <input
//                       type="radio"
//                       name="paymentMethod"
//                       value="cash"
//                       checked={formData.paymentMethod === "cash"}
//                       onChange={handleInputChange}
//                       className="w-4 h-4 text-orange-500 border-gray-300 focus:ring-orange-500"
//                     />
//                     <span className="ml-2 text-sm">
//                       {t("checkout.cash_on_delivery") || "Cash on Delivery"}
//                     </span>
//                   </label>

//                   {/*<label className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors">
//                     <input
//                       type="radio"
//                       name="paymentMethod"
//                       value="Rzrpay"
//                       checked={formData.paymentMethod === "Rzrpay"}
//                       onChange={handleInputChange}
//                       className="w-4 h-4 text-orange-500 border-gray-300 focus:ring-orange-500"
//                     />
//                     <span className="ml-2 text-sm">
//                       {t("checkout.pay_now") || "Pay now"}
//                     </span>
//                   </label>*/}
//                 </div>
//               </div>

//               {!selectedAddressId && (
//                 <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
//                   <p className="text-sm text-yellow-800">
//                     {t("checkout.select_address_warning") || "Please select a shipping address to continue"}
//                   </p>
//                 </div>
//               )}

//               <button
//                 onClick={handleSubmit}
//                 disabled={!isOrderValid()}
//                 className={`w-full font-semibold py-3 px-4 rounded-lg mt-6 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 ${
//                   isOrderValid()
//                     ? "bg-orange-500 hover:bg-orange-600 text-white"
//                     : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                 } ${isPlacingOrder ? "opacity-70" : ""}`}
//               >
//                 {isPlacingOrder ? (
//                   <div className="flex items-center justify-center">
//                     <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
//                     {t("checkout.placing_order") || "Placing Order..."}
//                   </div>
//                 ) : (
//                   t("checkout.place_order") || "Place Order"
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Checkout;



import React, { useState, useEffect } from "react";
import SelectAddressModal from "../../components/UserSideComponents/Order/SelectAddressModal";
import CheckoutSkeleton from "../../components/UserSideComponents/Order/CheckOutSkeleton";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { handleRazorpayPayment } from "../../utils/razorpay";
import { handleICICIPayment } from "../../utils/iciciPayment";
import { useCart } from "../../utils/CartContext";
import { useCurrency } from "../../context/CurrencyContext";
import { formatingPrice } from "../../utils/formatingPrice";
import { useTranslation } from "react-i18next";
import UserLoginModal from "../../components/Login/UserLoginModal";
import toast from "react-hot-toast";
import GuestSession from "../../utils/guestSession";

const Checkout = () => {
  const { currency, convertPrice } = useCurrency();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  const [formData, setFormData] = useState({
    paymentMethod: "cash",
  });
  const navigate = useNavigate();
  const { fetchCartCount } = useCart();
  const [cartData, setCartData] = useState({ items: [] }); // Initialize with empty items
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const [productData, setProductData] = useState(null);
  const [isBuyNow, setIsBuyNow] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [addressesFetched, setAddressesFetched] = useState(false);
  const [defaultAddress, setDefaultAddress] = useState(null);
  const [allAddresses, setAllAddresses] = useState([]);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [isGuestMode, setIsGuestMode] = useState(false);
  const [guestId, setGuestId] = useState(null);

  // Helper function to get localized text
  const getLocalizedText = (item, field) => {
    if (!item || !item[field]) return "";
    
    if (typeof item[field] === 'string') {
      return item[field];
    }
    
    if (typeof item[field] === 'object') {
      return item[field][currentLanguage] || 
             item[field].en || 
             item[field].hi || 
             item[field].es || 
             item[field].zh || 
             "";
    }
    
    return "";
  };

  const getUserData = () => {
    try {
      const userData = localStorage.getItem("pm-user-data");
      if (!userData) return null;
      return JSON.parse(userData);
    } catch (error) {
      console.error("Error parsing user data:", error);
      return null;
    }
  };

  const checkUserLogin = () => {
    const user = getUserData();
    if (user && user._id) {
      setIsLoggedIn(true);
      setLoggedInUser(user);
      setIsGuestMode(false);
      return user;
    }
    setIsLoggedIn(false);
    setLoggedInUser(null);
    
    const guest = GuestSession.getGuestId();
    if (guest) {
      setIsGuestMode(true);
      setGuestId(guest);
    }
    
    return null;
  };

  const handleLoginSuccess = (userData) => {
    localStorage.setItem("pm-user-data", JSON.stringify(userData));
    setIsLoggedIn(true);
    setLoggedInUser(userData);
    setIsGuestMode(false);
    setShowLoginModal(false);
    
    if (userData._id) {
      fetchUserCart(userData._id);
      fetchUserAddresses(userData._id);
    }
    
    window.dispatchEvent(new Event('storage'));
    toast.success(`${t("hello")}, ${userData.firstName || t("user")}!`);
  };

  const fetchUserAddresses = async (userId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/address/user/${userId}`
      );
      const data = await res.json();
      if (data.success && data.data.length > 0) {
        setAllAddresses(data.data);
        const defaultAddr = data.data.find((a) => a.isDefault);
        if (defaultAddr) {
          setDefaultAddress(defaultAddr);
          setSelectedAddressId(defaultAddr._id);
        } else {
          setDefaultAddress(data.data[0]);
          setSelectedAddressId(data.data[0]._id);
        }
      } else {
        setAllAddresses([]);
        setDefaultAddress(null);
        setSelectedAddressId(null);
      }
      setAddressesFetched(true);
    } catch (err) {
      console.error("Address fetch error:", err);
      setAddressesFetched(true);
    }
  };

  // Auto-select address when addresses are loaded
  useEffect(() => {
    if (allAddresses.length > 0 && !selectedAddressId) {
      const defaultAddr = allAddresses.find(a => a.isDefault) || allAddresses[0];
      if (defaultAddr) {
        setDefaultAddress(defaultAddr);
        setSelectedAddressId(defaultAddr._id);
        console.log("✅ Auto-selected address:", defaultAddr._id);
      }
    }
  }, [allAddresses, selectedAddressId]);

  const fetchGuestCart = async () => {
    try {
      setLoading(true);
      const guestId = GuestSession.getGuestId();
      
      if (!guestId) {
        setCartData({ items: [] });
        setLoading(false);
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/cart/get-guest-cart/${guestId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        if (response.status === 404) {
          setCartData({ items: [] });
          setLoading(false);
          return;
        }
        throw new Error(t("checkout.cart_fetch_failed") || "Failed to fetch cart data");
      }

      const data = await response.json();
      // Ensure we have items array
      setCartData({
        items: data.data?.items || data.items || []
      });
      setLoading(false);
    } catch (err) {
      console.error("Guest cart fetch error:", err);
      setCartData({ items: [] });
      setError(err.message);
      setLoading(false);
    }
  };

  const fetchUserCart = async (userId) => {
    try {
      setLoading(true);
      const userData = userId ? { _id: userId } : getUserData();
      if (!userData || !userData._id) {
        setCartData({ items: [] });
        setLoading(false);
        throw new Error(t("checkout.user_not_found") || "User not found. Please login first.");
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/cart/get-cart/${userData._id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        if (response.status === 404) {
          setCartData({ items: [] });
          setLoading(false);
          return;
        }
        throw new Error(t("checkout.cart_fetch_failed") || "Failed to fetch cart data");
      }

      const data = await response.json();
      // Ensure we have items array
      setCartData({
        items: data.data?.items || data.items || []
      });
      setLoading(false);
    } catch (err) {
      console.error("User cart fetch error:", err);
      setCartData({ items: [] });
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'pm-user-data') {
        const user = checkUserLogin();
        if (user && user._id) {
          fetchUserCart(user._id);
          fetchUserAddresses(user._id);
        } else {
          const guest = GuestSession.getGuestId();
          if (guest) {
            setIsGuestMode(true);
            setGuestId(guest);
            fetchGuestCart();
          }
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    const user = checkUserLogin();
    const buyNowProduct = localStorage.getItem("buy-now-product");
    
    if (buyNowProduct) {
      setProductData(JSON.parse(buyNowProduct));
      setIsBuyNow(true);
      setLoading(false);
      
      if (user && user._id) {
        fetchUserAddresses(user._id);
      }
      return;
    }

    if (user && user._id) {
      fetchUserCart(user._id);
      fetchUserAddresses(user._id);
    } else {
      setIsGuestMode(true);
      const guest = GuestSession.getGuestId();
      if (guest) {
        setGuestId(guest);
        fetchGuestCart();
      } else {
        setCartData({ items: [] });
        setLoading(false);
      }
      
      setTimeout(() => {
        setShowLoginModal(true);
      }, 1500);
    }

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (isLoggedIn && loggedInUser) {
      const user = getUserData();
      if (user && user._id) {
        const buyNowProduct = localStorage.getItem("buy-now-product");
        if (buyNowProduct) {
          setProductData(JSON.parse(buyNowProduct));
          setIsBuyNow(true);
          setLoading(false);
        } else {
          fetchUserCart(user._id);
        }
        fetchUserAddresses(user._id);
      }
    }
  }, [isLoggedIn]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAddressSelect = (addressId) => {
    console.log("📦 Address selected manually:", addressId);
    setSelectedAddressId(addressId);
    const selected = allAddresses.find(a => a._id === addressId);
    if (selected) {
      setDefaultAddress(selected);
    }
  };

  const clearUserCart = async (userId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/cart/clear-cart?userId=${userId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(t("checkout.clear_cart_failed") || "Failed to clear cart");
      }

      const result = await response.json();
      console.log("Cart cleared successfully:", result);
      return result;
    } catch (error) {
      console.error("Error clearing cart:", error);
      throw error;
    }
  };

  const clearGuestCart = async (guestId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/cart/clear-cart?guestId=${guestId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(t("checkout.clear_cart_failed") || "Failed to clear cart");
      }

      const result = await response.json();
      console.log("Guest cart cleared successfully:", result);
      return result;
    } catch (error) {
      console.error("Error clearing guest cart:", error);
      throw error;
    }
  };

  const placeOrder = async () => {
    try {
      setIsPlacingOrder(true);
      const userData = getUserData();
      const isGuest = !userData || !userData._id;
      
      let orderData;
      let identifier;
      let identifierType;

      if (!isGuest) {
        identifier = userData._id;
        identifierType = 'userId';
      } else {
        const guest = GuestSession.getGuestId();
        if (!guest) {
          throw new Error(t("checkout.guest_session_expired") || "Guest session expired. Please login.");
        }
        identifier = guest;
        identifierType = 'guestId';
      }

      // Validate address selection
      if (!selectedAddressId) {
        throw new Error(t("checkout.select_address") || "Please select a shipping address.");
      }

      if (isBuyNow) {
        if (!productData) {
          throw new Error(t("checkout.no_product_data") || "No product data found.");
        }

        orderData = {
          [identifierType]: identifier,
          products: [
            {
              product: productData.product._id,
              quantity: productData.quantity,
            },
          ],
          shippingAddress: selectedAddressId,
          paymentMethod: formData.paymentMethod,
        };
      } else {
        // Get items safely
        const cartItems = cartData?.items || [];
        if (cartItems.length === 0) {
          throw new Error(t("checkout.cart_empty") || "Your cart is empty.");
        }

        const products = cartItems.map((item) => ({
          product: item.product._id,
          quantity: item.quantity,
        }));

        orderData = {
          [identifierType]: identifier,
          products: products,
          shippingAddress: selectedAddressId,
          paymentMethod: formData.paymentMethod,
        };
      }

      if (isGuest) {
        orderData.isGuest = true;
        orderData.guestEmail = localStorage.getItem('guest_email') || '';
        orderData.guestPhone = localStorage.getItem('guest_phone') || '';
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/orders/place-order`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(orderData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || t("checkout.order_failed") || "Failed to place order");
      }

      const result = await response.json();
      console.log("Order placed successfully:", result);

      if (isBuyNow) {
        localStorage.removeItem("buy-now-product");
        fetchCartCount();
      } else {
        try {
          if (!isGuest) {
            await clearUserCart(identifier);
          } else {
            await clearGuestCart(identifier);
          }
          setCartData({ items: [] });
          fetchCartCount();
        } catch (cartError) {
          console.error("Failed to clear cart after order placement:", cartError);
        }
      }

      const successMessage = isGuest 
        ? t("checkout.guest_order_success") || "Your order has been placed! Create an account to track your orders."
        : t("checkout.order_success_title") || "Order placed successfully!";

      Swal.fire({
        title: isGuest ? t("checkout.order_placed") || "Order Placed!" : t("checkout.order_success_title") || "Order placed successfully!",
        text: successMessage,
        icon: "success",
        confirmButtonText: t("checkout.ok") || "OK",
        draggable: true,
      }).then((result) => {
        if (result.isConfirmed) {
          if (isGuest) {
            Swal.fire({
              title: t("checkout.create_account") || "Create Account?",
              text: t("checkout.create_account_message") || "Create an account to track your orders and get updates.",
              icon: "question",
              showCancelButton: true,
              confirmButtonText: t("checkout.sign_up") || "Sign Up",
              cancelButtonText: t("checkout.later") || "Later",
            }).then((result) => {
              if (result.isConfirmed) {
                setShowLoginModal(true);
              } else {
                navigate("/");
              }
            });
          } else {
            navigate("/user-orders");
          }
        }
      });
    } catch (err) {
      console.error("Error placing order:", err);
      Swal.fire({
        title: t("checkout.error") || "Error!",
        text: `${t("checkout.order_error_prefix") || "Error placing order:"} ${err.message}`,
        icon: "error",
        draggable: true,
      });
    } finally {
      setIsPlacingOrder(false);
    }
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   const userData = getUserData();
  //   const totalAmount = isBuyNow ? calculateBuyNowTotal() : calculateTotal();

  //   if (formData.paymentMethod === "cash") {
  //     placeOrder();
  //   } else {
  //     handleRazorpayPayment({
  //       amount: totalAmount,
  //       user: userData,
  //       onSuccess: () => placeOrder(),
  //       onFail: () => Swal.fire(
  //         t("checkout.error") || "Error", 
  //         t("checkout.payment_failed") || "Payment failed", 
  //         "error"
  //       ),
  //     });
  //   }
  // };

  const handleSubmit = (e) => {
  e.preventDefault();

  const userData = getUserData();
  const totalAmount = isBuyNow ? calculateBuyNowTotal() : calculateTotal();

  // Validate payment method is selected
  if (!formData.paymentMethod) {
    Swal.fire(
      t("checkout.error") || "Error",
      t("checkout.select_payment_method") || "Please select a payment method",
      "warning"
    );
    return;
  }

  if (formData.paymentMethod === "cash") {
    // Cash on Delivery - place order directly
    placeOrder();
  } else if (formData.paymentMethod === "online") {
    // Online Payment - handle Razorpay
    handleRazorpayPayment({
      amount: totalAmount,
      user: userData || { _id: 'guest' }, // Pass user data
      onSuccess: () => {
        // After successful payment, place the order
        placeOrder();
      },
      onFail: () => {
        // Payment failed or cancelled
        Swal.fire(
          t("checkout.error") || "Error",
          t("checkout.payment_failed") || "Payment failed. Please try again.",
          "error"
        );
      },
    });
  } else if (formData.paymentMethod === "icici") {
    // ICICI Bank Payment Gateway
    
    // We need to construct orderData first because ICICI redirects away
    const isGuest = !userData || !userData._id;
    let identifier = isGuest ? GuestSession.getGuestId() : userData._id;
    let identifierType = isGuest ? 'guestId' : 'userId';
    
    if (!selectedAddressId) {
      Swal.fire(t("checkout.error") || "Error", t("checkout.select_address") || "Please select a shipping address.", "warning");
      return;
    }

    let orderData = {
      [identifierType]: identifier,
      shippingAddress: selectedAddressId,
      paymentMethod: "icici",
    };

    if (isBuyNow) {
      if (!productData) return;
      orderData.products = [{ product: productData.product._id, quantity: productData.quantity }];
    } else {
      const cartItems = cartData?.items || [];
      if (cartItems.length === 0) return;
      orderData.products = cartItems.map((item) => ({ product: item.product._id, quantity: item.quantity }));
    }

    if (isGuest) {
      orderData.isGuest = true;
      orderData.guestEmail = localStorage.getItem('guest_email') || '';
      orderData.guestPhone = localStorage.getItem('guest_phone') || '';
    }

    handleICICIPayment({
      amount: totalAmount,
      user: userData || { _id: 'guest' },
      orderData: orderData,
      onFail: () => {
        Swal.fire(
          t("checkout.error") || "Error",
          t("checkout.payment_failed") || "Payment failed. Please try again.",
          "error"
        );
      }
    });
  }
};

  const calculateBuyNowSubtotal = () => {
    if (!productData) return 0;
    return productData.product.price * productData.quantity;
  };

  const calculateBuyNowShipping = () => {
    if (!productData) return 0;
    const shippingCharge = productData.product.shippingCharge || 0;
    return shippingCharge * productData.quantity;
  };

  const calculateBuyNowGST = () => {
    if (!productData) return 0;
    const gstPercentage = productData.product.gstPercentage || 0;
    return (productData.product.price * productData.quantity * gstPercentage) / 100;
  };

  const calculateBuyNowExtraTax = () => {
    if (!productData) return 0;
    const extraTaxPercentage = productData.product.extraTaxPercentage || 0;
    return (productData.product.price * productData.quantity * extraTaxPercentage) / 100;
  };

  const calculateBuyNowTotal = () => {
    const subtotal = calculateBuyNowSubtotal();
    const shipping = calculateBuyNowShipping();
    const gst = calculateBuyNowGST();
    const extraTax = calculateBuyNowExtraTax();
    return subtotal + shipping + gst + extraTax;
  };

  const calculateSubtotal = () => {
    const items = cartData?.items || [];
    return items.reduce((total, item) => {
      return total + (item.product?.price || 0) * item.quantity;
    }, 0);
  };

  const calculateShipping = () => {
    const items = cartData?.items || [];
    return items.reduce((total, item) => {
      const shippingCharge = item.product?.shippingCharge || 0;
      return total + shippingCharge * item.quantity;
    }, 0);
  };

  const calculateGST = () => {
    const items = cartData?.items || [];
    return items.reduce((total, item) => {
      const gstPercentage = item.product?.gstPercentage || 0;
      const price = item.product?.price || 0;
      return total + (price * item.quantity * gstPercentage) / 100;
    }, 0);
  };

  const calculateExtraTax = () => {
    const items = cartData?.items || [];
    return items.reduce((total, item) => {
      const extraTaxPercentage = item.product?.extraTaxPercentage || 0;
      const price = item.product?.price || 0;
      return total + (price * item.quantity * extraTaxPercentage) / 100;
    }, 0);
  };

  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const shipping = calculateShipping();
    const gst = calculateGST();
    const extraTax = calculateExtraTax();
    return subtotal + shipping + gst + extraTax;
  };

  const getCartItems = () => {
    if (isBuyNow) {
      return productData ? [productData] : [];
    }
    return cartData?.items || [];
  };

  // const isOrderValid = () => {
  //   const items = getCartItems();
  //   const hasItems = items.length > 0;
  //   const hasAddress = !!selectedAddressId;
  //   const isValid = hasItems && hasAddress && !isPlacingOrder;
    
  //   console.log("🔍 Cart Order Valid:", { 
  //     hasItems, 
  //     itemCount: items.length,
  //     selectedAddressId, 
  //     isPlacingOrder,
  //     isValid 
  //   });
  //   return isValid;
  // };

  // Debug logging
  
  const isOrderValid = () => {
  const items = getCartItems();
  const hasItems = items.length > 0;
  const hasAddress = !!selectedAddressId;
  const hasPaymentMethod = !!formData.paymentMethod;
  const isValid = hasItems && hasAddress && hasPaymentMethod && !isPlacingOrder;
  
  console.log("🔍 Order Validation:", { 
    hasItems, 
    itemCount: items.length,
    selectedAddressId, 
    hasPaymentMethod,
    paymentMethod: formData.paymentMethod,
    isPlacingOrder,
    isValid 
  });
  return isValid;
};

  useEffect(() => {
    const items = getCartItems();
    console.log("🔍 Checkout State:", {
      isLoggedIn,
      isGuestMode,
      cartItems: items.length,
      cartDataStructure: cartData,
      selectedAddressId,
      allAddressesCount: allAddresses.length,
      defaultAddress: defaultAddress?._id,
      isCartEmpty: items.length === 0,
      isOrderValid: isOrderValid(),
    });
  }, [cartData, selectedAddressId, allAddresses, defaultAddress, isLoggedIn, isGuestMode, isBuyNow, productData]);

  if (!isLoggedIn && !isGuestMode && !loading) {
    return (
      <>
        {showLoginModal && (
          <UserLoginModal
            onClose={() => {
              setShowLoginModal(false);
              navigate("/");
            }}
            onLoginSuccess={handleLoginSuccess}
          />
        )}
        
        <div className="min-h-screen bg-[#FBFBFB] flex items-center justify-center">
          <div className="text-center max-w-md mx-auto p-8 bg-white rounded-lg shadow-lg">
            <div className="mb-6">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-10 h-10 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">Login Required</h2>
              <p className="text-gray-600">Please login to proceed to checkout.</p>
              <p className="text-sm text-gray-500 mt-2">Your cart items will be saved.</p>
            </div>
            <button
              onClick={() => setShowLoginModal(true)}
              className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg transition-colors duration-200 font-semibold w-full"
            >
              Login Now
            </button>
            <button
              onClick={() => navigate("/")}
              className="mt-3 text-gray-500 hover:text-gray-700 text-sm w-full"
            >
              Continue Shopping
            </button>
          </div>
        </div>
      </>
    );
  }

  if (loading) {
    return <CheckoutSkeleton />;
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#FBFBFB] flex items-center justify-center">
        <div className="text-center max-w-md mx-auto p-8 bg-white rounded-lg shadow-lg">
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
          <button
            onClick={() => navigate("/")}
            className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg transition-colors duration-200 font-semibold"
          >
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  const items = getCartItems();
  const isCartEmpty = items.length === 0;

  return (
    <>
      {showLoginModal && (
        <UserLoginModal
          onClose={() => {
            setShowLoginModal(false);
          }}
          onLoginSuccess={handleLoginSuccess}
        />
      )}

      <div className="py-10 bg-[#FBFBFB]">
        <div className="mx-auto px-4 md:px-10">
          {isGuestMode && (
            <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
              <div className="flex items-start gap-3">
                <div className="mt-1">
                  <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm text-blue-800 font-medium">
                    {t("checkout.guest_mode") || "You're checking out as a guest"}
                  </p>
                  <p className="text-xs text-blue-600">
                    {t("checkout.guest_mode_message") || "Login to save your cart, track orders, and get faster checkout."}
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShowLoginModal(true)}
                className="whitespace-nowrap bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
              >
                {t("checkout.login_or_signup") || "Login / Sign Up"}
              </button>
            </div>
          )}

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              {isGuestMode && !addressesFetched ? (
                <div className="bg-white rounded-lg shadow-sm p-6">
                  <h2 className="text-xl font-semibold font-philosopher mb-4">
                    {t("checkout.shipping_address") || "Shipping Address"}
                  </h2>
                  <div className="space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          {t("checkout.first_name") || "First Name"}
                        </label>
                        <input
                          type="text"
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                          placeholder={t("checkout.first_name_placeholder") || "Enter first name"}
                          onChange={(e) => {
                            localStorage.setItem('guest_first_name', e.target.value);
                          }}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          {t("checkout.last_name") || "Last Name"}
                        </label>
                        <input
                          type="text"
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                          placeholder={t("checkout.last_name_placeholder") || "Enter last name"}
                          onChange={(e) => {
                            localStorage.setItem('guest_last_name', e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {t("checkout.email") || "Email"}
                      </label>
                      <input
                        type="email"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                        placeholder={t("checkout.email_placeholder") || "Enter email address"}
                        onChange={(e) => {
                          localStorage.setItem('guest_email', e.target.value);
                        }}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {t("checkout.phone") || "Phone"}
                      </label>
                      <input
                        type="tel"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                        placeholder={t("checkout.phone_placeholder") || "Enter phone number"}
                        onChange={(e) => {
                          localStorage.setItem('guest_phone', e.target.value);
                        }}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {t("checkout.address") || "Address"}
                      </label>
                      <textarea
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                        rows="3"
                        placeholder={t("checkout.address_placeholder") || "Enter full address"}
                        onChange={(e) => {
                          localStorage.setItem('guest_address', e.target.value);
                        }}
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          {t("checkout.city") || "City"}
                        </label>
                        <input
                          type="text"
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                          placeholder={t("checkout.city_placeholder") || "Enter city"}
                          onChange={(e) => {
                            localStorage.setItem('guest_city', e.target.value);
                          }}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          {t("checkout.pincode") || "Pincode"}
                        </label>
                        <input
                          type="text"
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-orange-500 focus:border-orange-500"
                          placeholder={t("checkout.pincode_placeholder") || "Enter pincode"}
                          onChange={(e) => {
                            localStorage.setItem('guest_pincode', e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <SelectAddressModal 
                  onAddressSelect={handleAddressSelect}
                  selectedAddressId={selectedAddressId}
                />
              )}
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-lg shadow-sm p-6 sticky top-6">
                <h2 className="text-xl font-semibold font-philosopher mb-6">
                  {t("checkout.order_summary") || "Order Summary"}
                </h2>

                <div className="space-y-4 mb-6">
                  {isBuyNow ? (
                    productData ? (
                      <div className="flex items-center space-x-3">
                        <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden">
                          <img
                            className="h-full w-full object-cover"
                            src={productData.product.images?.[0] || "https://via.placeholder.com/100x100?text=Product"}
                            alt={getLocalizedText(productData.product, "name") || t("checkout.untitled_product") || "Untitled Product"}
                            onError={(e) => {
                              e.target.src = "https://via.placeholder.com/100x100?text=Product";
                            }}
                          />
                        </div>
                        <div className="flex-1">
                          <h4 className="font-medium text-sm">
                            {getLocalizedText(productData.product, "name") || t("checkout.untitled_product") || "Untitled Product"}
                          </h4>
                          <p className="text-sm text-gray-500">
                            x{productData.quantity}
                          </p>
                          <p className="text-xs text-gray-400">
                            {getLocalizedText(productData.product, "measurement") || ""}
                          </p>
                        </div>
                        <span className="font-semibold">
                          {formatingPrice(
                            convertPrice(productData.product.price * productData.quantity),
                            currency
                          )}
                        </span>
                      </div>
                    ) : (
                      <div className="text-center py-8 text-gray-500">
                        {t("checkout.no_product") || "No product found"}
                      </div>
                    )
                  ) : items.length > 0 ? (
                    items.map((item) => {
                      const productName = getLocalizedText(item.product, "name") || t("checkout.untitled_product") || "Untitled Product";
                      const measurement = getLocalizedText(item.product, "measurement") || "";
                      
                      return (
                        <div key={item._id || item.id} className="flex items-center space-x-3">
                          <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden">
                            <img
                              className="h-full w-full object-cover"
                              src={item.product?.images?.[0] || "https://via.placeholder.com/100x100?text=Product"}
                              alt={productName}
                              onError={(e) => {
                                e.target.src = "https://via.placeholder.com/100x100?text=Product";
                              }}
                            />
                          </div>
                          <div className="flex-1">
                            <h4 className="font-medium text-sm line-clamp-2">
                              {productName}
                            </h4>
                            <p className="text-sm text-gray-500">
                              x{item.quantity}
                            </p>
                            {measurement && (
                              <p className="text-xs text-gray-400">
                                {measurement}
                              </p>
                            )}
                          </div>
                          <span className="font-semibold whitespace-nowrap">
                            {formatingPrice(
                              convertPrice((item.product?.price || 0) * item.quantity),
                              currency
                            )}
                          </span>
                        </div>
                      );
                    })
                  ) : (
                    <div className="text-center py-8 text-gray-500">
                      {t("checkout.cart_empty_display") || "Your cart is empty"}
                    </div>
                  )}
                </div>

                {(isBuyNow && productData) || items.length > 0 ? (
                  <div className="border-t pt-4 space-y-2">
                    <div className="flex justify-between text-sm">
                      <span>{t("checkout.subtotal") || "Subtotal"}:</span>
                      <span>
                        {formatingPrice(
                          convertPrice(
                            isBuyNow
                              ? calculateBuyNowSubtotal()
                              : calculateSubtotal()
                          ),
                          currency
                        )}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span>{t("checkout.shipping") || "Shipping"}:</span>
                      <span>
                        {formatingPrice(
                          convertPrice(
                            isBuyNow
                              ? calculateBuyNowShipping()
                              : calculateShipping()
                          ),
                          currency
                        )}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span>{t("checkout.gst") || "GST"}:</span>
                      <span>
                        {formatingPrice(
                          convertPrice(
                            isBuyNow ? calculateBuyNowGST() : calculateGST()
                          ),
                          currency
                        )}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span>{t("checkout.extra_tax") || "Extra Tax"}:</span>
                      <span>
                        {formatingPrice(
                          convertPrice(
                            isBuyNow
                              ? calculateBuyNowExtraTax()
                              : calculateExtraTax()
                          ),
                          currency
                        )}
                      </span>
                    </div>
                    <div className="flex justify-between font-semibold font-philosopher text-lg pt-2 border-t">
                      <span>{t("checkout.total") || "Total"}:</span>
                      <span>
                        {formatingPrice(
                          convertPrice(
                            isBuyNow ? calculateBuyNowTotal() : calculateTotal()
                          ),
                          currency
                        )}
                      </span>
                    </div>
                  </div>
                ) : null}

                {/* <div className="mt-6">
                  <h3 className="font-semibold text-xl font-philosopher mb-4">
                    {t("checkout.payment_method") || "Payment Method"}
                  </h3>
                  <div className="space-y-3">
                    <label className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors">
                      <input
                        type="radio"
                        name="paymentMethod"
                        value="cash"
                        checked={formData.paymentMethod === "cash"}
                        onChange={handleInputChange}
                        className="w-4 h-4 text-orange-500 border-gray-300 focus:ring-orange-500"
                      />
                      <span className="ml-2 text-sm">
                        {t("checkout.cash_on_delivery") || "Cash on Delivery"}
                      </span>
                    </label>
                  </div>
                </div> */}

<div className="mt-6">
  <h3 className="font-semibold text-xl font-philosopher mb-4">
    {t("checkout.payment_method") || "Payment Method"}
  </h3>
  
  <div className="space-y-3">
    {/* Cash on Delivery */}
    <div 
      className={`border-2 rounded-lg p-3 transition-all cursor-pointer ${
        formData.paymentMethod === "cash" 
          ? "border-orange-500 bg-orange-50" 
          : "border-gray-200 hover:border-gray-300"
      }`}
      onClick={() => setFormData(prev => ({ ...prev, paymentMethod: "cash" }))}
    >
      <label className="flex items-center cursor-pointer">
        <input
          type="radio"
          name="paymentMethod"
          value="cash"
          checked={formData.paymentMethod === "cash"}
          onChange={handleInputChange}
          className="w-4 h-4 text-orange-500 border-gray-300 focus:ring-orange-500"
        />
        <div className="ml-3">
          <span className="font-medium text-sm block">
            {t("checkout.cash_on_delivery") || "Cash on Delivery"}
          </span>
          <span className="text-xs text-gray-500">
            Pay when you receive the order
          </span>
        </div>
      </label>
    </div>

    {/* Online Payment */}
    <div 
      className={`border-2 rounded-lg p-3 transition-all cursor-pointer ${
        formData.paymentMethod === "online" 
          ? "border-orange-500 bg-orange-50" 
          : "border-gray-200 hover:border-gray-300"
      }`}
      onClick={() => setFormData(prev => ({ ...prev, paymentMethod: "online" }))}
    >
      <label className="flex items-center cursor-pointer">
        <input
          type="radio"
          name="paymentMethod"
          value="online"
          checked={formData.paymentMethod === "online"}
          onChange={handleInputChange}
          className="w-4 h-4 text-orange-500 border-gray-300 focus:ring-orange-500"
        />
        <div className="ml-3 flex-1">
          <div className="flex items-center justify-between">
            <span className="font-medium text-sm">
              {t("online_payment") || "Online Payment"} (Razorpay)
            </span>
            <img 
              src="https://cdn.razorpay.com/static/assets/logo.svg" 
              alt="Razorpay" 
              className="h-5"
            />
          </div>
          <span className="text-xs text-gray-500">
            Credit/Debit Card • UPI • Net Banking
          </span>
        </div>
      </label>
    </div>

    {/* ICICI Bank Payment */}
    <div 
      className={`border-2 rounded-lg p-3 transition-all cursor-pointer ${
        formData.paymentMethod === "icici" 
          ? "border-orange-500 bg-orange-50" 
          : "border-gray-200 hover:border-gray-300"
      }`}
      onClick={() => setFormData(prev => ({ ...prev, paymentMethod: "icici" }))}
    >
      <label className="flex items-center cursor-pointer">
        <input
          type="radio"
          name="paymentMethod"
          value="icici"
          checked={formData.paymentMethod === "icici"}
          onChange={handleInputChange}
          className="w-4 h-4 text-orange-500 border-gray-300 focus:ring-orange-500"
        />
        <div className="ml-3 flex-1">
          <div className="flex items-center justify-between">
            <span className="font-medium text-sm">
              ICICI Bank Payment Gateway
            </span>
            <span className="font-bold text-orange-500 text-sm">
              ICICI
            </span>
          </div>
          <span className="text-xs text-gray-500">
            Secure Payment Gateway by ICICI Bank
          </span>
        </div>
      </label>
    </div>
  </div>

  {/* Show payment method selection warning */}
  {!formData.paymentMethod && !isPlacingOrder && (
    <div className="mt-3 p-2 bg-yellow-50 border border-yellow-200 rounded-lg">
      <p className="text-xs text-yellow-800">
        ⚠️ {t("checkout.select_payment_method") || "Please select a payment method"}
      </p>
    </div>
  )}
</div>

                {!selectedAddressId && !isGuestMode && allAddresses.length > 0 && (
                  <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                    <p className="text-sm text-yellow-800">
                      {t("checkout.select_address_warning") || "Please select a shipping address to continue"}
                    </p>
                  </div>
                )}

                {isGuestMode && (
                  <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="text-sm text-blue-800">
                      {t("checkout.guest_address_warning") || "Please fill in your shipping details to continue"}
                    </p>
                  </div>
                )}

                {isCartEmpty && !isBuyNow && (
                  <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-sm text-red-600">
                      {t("checkout.cart_empty_warning") || "Your cart is empty. Please add items to your cart first."}
                    </p>
                  </div>
                )}

                <button
                  onClick={handleSubmit}
                  disabled={!isOrderValid()}
                  className={`w-full font-semibold py-3 px-4 rounded-lg mt-6 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 ${
                    isOrderValid()
                      ? "bg-orange-500 hover:bg-orange-600 text-white"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed"
                  } ${isPlacingOrder ? "opacity-70" : ""}`}
                >
                  {isPlacingOrder ? (
                    <div className="flex items-center justify-center">
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                      {t("checkout.placing_order") || "Placing Order..."}
                    </div>
                  ) : (
                    <>
                      {t("checkout.place_order") || "Place Order"}
                      {!isOrderValid() && !isCartEmpty && !isBuyNow && (
                        <span className="ml-2 text-xs opacity-70">
                          {!selectedAddressId ? "(Select Address)" : 
                           items.length === 0 ? "(Cart Empty)" : ""}
                        </span>
                      )}
                      {!isOrderValid() && isBuyNow && (
                        <span className="ml-2 text-xs opacity-70">
                          {!selectedAddressId ? "(Select Address)" : 
                           !productData ? "(No Product)" : ""}
                        </span>
                      )}
                    </>
                  )}
                </button>

                {isGuestMode && (
                  <p className="text-xs text-gray-500 text-center mt-3">
                    {t("checkout.guest_checkout_note") || "You're checking out as a guest. Create an account after order placement to track your orders."}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Checkout;